<template>
  <div class="container-page">
    <p class="title-inner">Отчет международных организаций о торговле</p>
    <TecWorldTable :nn="nn" v-if="canView" />
  </div>
</template>

<script>
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import TecWorldTable from '@/modules/importanalytics/components/TecWorldTable.vue';

  export default {
    name: 'TecWorldView',
    components: { TecWorldTable },
    mixins: [security],
    data() {
      return {
        canView: false,
        nn: 1,
      };
    },
    created() {
      this.checkPermission(Constants.Permissions.FreeTradeAgreement).then((response) => {
        this.canView = response.data;
        if (!this.canView) {
          this.notAccess();
        }
      });
    },
    methods: {},
    computed: {},
  };
</script>

<style lang="scss"></style>
